const envs: any = {
  test: {
    editorUrl: 'https://ide.jinx.corp.kuaishou.com',
    dspUrl: 'https://feat-t1852643-playable-uniform--kuaishou-frontend-dsp.jinx.corp.kuaishou.com',
  },
  staging: {
    editorUrl: 'https://ide.jinx.staging.kuaishou.com',
    // dspUrl: 'https://beta-ad-e.corp.kuaishou.com',
    dspUrl: 'https://chore-staging--kuaishou-frontend-dsp.jinx.staging.kuaishou.com',
  },
  beta: {
    editorUrl: 'https://linglu.corp.kuaishou.com/editor',
    // dspUrl: 'https://beta-ad-e.corp.kuaishou.com',
    dspUrl: 'https://dsp-beta2.corp.kuaishou.com',
  },
  production: {
    editorUrl: 'https://linglu.e.kuaishou.com/editor',
    dspUrl: 'https://ad.e.kuaishou.com',
  },
};
interface IEnv {
  editorUrl: string;
  dspUrl: string;
}
const stage =
  !process.env.REACT_APP_STAGE || process.env.REACT_APP_STAGE === 'local'
    ? 'test'
    : process.env.REACT_APP_STAGE;

export default envs[stage] as IEnv;
